<template>
  <div>
    <div
      class="row center-xs"
      style="margin: 0px; box-sizing: border-box;"
      v-if="!isUserLegal"
    >
      <registration-step
        v-for="(step, step_index) in steps"
        :key="`step-${step_index + 1}`"
        :stepNumber="step_index + 1"
        :label="step.label"
        @click.native="goToStep(step)"
      />
    </div>
    <div
      class="row center-xs"
      style="margin: 0px; box-sizing: border-box;"
      v-else
    >
      <registration-step
        v-for="(step, step_index) in legal_steps"
        :key="`step-${step_index + 1}`"
        :stepNumber="step_index + 1"
        :label="step.label"
        @click.native="goToStep(step)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RegistrationStep from "@/components/register/RegistrationStep";

export default {
  components: {
    "registration-step": RegistrationStep
  },
  data() {
    return {
      steps: [
        {
          label: "Общая информация",
          open: false,
          to: { name: "general-info" }
        },
        {
          label: "Источники финансирования",
          open: false,
          to: { name: "income-info" }
        },
        {
          label: "Коммерческие условия",
          open: false,
          to: { name: "commercial-conditions" }
        },
        {
          label: "Загрузка документов",
          open: false,
          to: { name: "file-upload" }
        },
        {
          label: "Завершение",
          open: false,
          to: { name: "register-finish" }
        }
      ],
      legal_steps: [
        {
          label: "Общая информация",
          open: false,
          to: { name: "legal-entity-register" }
        },
        {
          label: "Структура",
          open: false,
          to: { name: "legal-control-list" }
        },
        {
          label: "Источники финансирования",
          open: false,
          to: { name: "income-info" }
        },
        {
          label: "Коммерческие условия",
          open: false,
          to: { name: "commercial-conditions" }
        },
        {
          label: "Завершение",
          open: false,
          to: { name: "register-finish" }
        }
      ]
    };
  },
  methods: {
    goToStep(step) {
      if (step.open) {
        this.$router.push(step.to);
      } else {
        this.$toasted.show("Заполните формы");
      }
    }
  },
  computed: {
    ...mapGetters(["currentRegistrationStep", "isUserLegal"])
  }
};
</script>

<style scoped>
.container {
  display: flex;
  align-items: center;
}

.item {
  margin-right: 30px;
}
</style>
